$(document).ready(function(){

 var theTotal = 0;
 $('.build-bottom').hide()
  $(document).on("click",".build-atc-btn.var-available",function() {  
    $(this).parents('.build-item').addClass('border');
    $(this).addClass('active').text('Add Another');
    var image = $(this).data("img");
    var id = $(this).data("id");
    var price = $(this).data("price");
    
   $.ajax({
      type: 'POST',
      context: this,
      url: '/cart/add.js',
      data: { quantity: 1, id: id },
      dataType: 'json',
      success: function() {
      if($(window).width() <= 767 ){
        showCartdrawer();
        AddCartBuble();
      }  
      else{  
         AddCartBuble();
      }
     },
    });

    var images = $('ul.add-items-wrapped li img');
      for (var i = 0; i < images.length; i++) {
        if($(images[i]).attr('src') == ''){
          $(images[i]).attr('src', image);
          $(images[i]).parents('li').find('span').attr('data-id', id);
          $(images[i]).parents('li').find('span').attr('data-price', price);
          $(images[i]).parent().removeClass('hidden');
          break;
        }
      }
  
      theTotal = Number(theTotal) + Number(price);
      $('.total-price').text("$" + theTotal.toFixed(2));
      $('.build-bottom').show()

      var storage_data = localStorage.getItem("storage_data") ? JSON.parse(localStorage.getItem("storage_data")) : [];
      var store_list = ({id,image,price});  
      storage_data.push(store_list);
      localStorage.setItem("storage_data", JSON.stringify(storage_data)); 
     
      if(storage_data.length > 6){
        var list = "<li class='inner-item'><div class='img-box'><img src='"+image+"'/><span data-price='"+price+"' data-id='"+id+"' class='close-item'>X</span></div></li>";
        $(".add-items-wrapped").append(list);
      }

      if(storage_data.length <= 4){
         var left_item = 4 - storage_data.length;
         $('.saving p').text('Currently saving 10% - Add '+left_item+' more for 20% savings');
         if(left_item == 0){
            $('.saving p').text('Congratulations you got 20% savings');
         }
      }else if(storage_data.length > 4 && storage_data.length <= 6){
         var left_item = 6 - storage_data.length;
         $('.saving p').text('Currently saving 20% - Add '+left_item+' more for 30% savings');
         if(left_item == 0){
            $('.saving p').text('Congratulations you got 30% savings');
         }
        else if(storage_data.length > 6){
          $('.saving p').text('Congratulations you got 30% savings');
        }
       }

}); 
  
function printList() {
    var listHTML = "";
    var storage_value = localStorage.getItem("storage_data") ? JSON.parse(localStorage.getItem("storage_data")) : [];
    
    if(storage_value.length){
       for(var i = 0; i < storage_value.length; i++) {
          var id = storage_value[i].id;
          var image = storage_value[i].image;
          var price =  storage_value[i].price;
            listHTML += "<li class='inner-item'><div class='img-box'><img src='"+image+"'/><span data-price='"+price+"' data-id='"+id+"' class='close-item'>X</span></div></li>";  
       }

        $.each(storage_value,function(index,value){
          theTotal += parseInt(value.price );
        });
     
        $('.build-bottom').show()
        $('.total-price').text("$" + theTotal.toFixed(2));
      
        if(storage_value.length <= 4){
         var left_item = 4 - storage_value.length;
         $('.saving p').text('Currently saving 10% - Add '+left_item+' more for 20% savings');
         if(left_item == 0){
            $('.saving p').text('Congratulations you got 20% savings');
         }
        }
      
        if(storage_value.length > 4 && storage_value.length <= 6 ){
         var left_item = 6 - storage_value.length;
         $('.saving p').text('Currently saving 20% - Add '+left_item+' more for 30% savings');
         if(left_item == 0){
            $('.saving p').text('Congratulations you got 30% savings');
         }
        }

       if(storage_value.length > 6 ){
         $('.saving p').text('Congratulations you got 30% savings');
       }
       
     }
     if(storage_value.length < 6){
      var rows = 6 - storage_value.length;
      for(var i = 0; i < rows; i++) {
          listHTML += "<li class='inner-item'><div class='img-box hidden'><img src=''/><span data-price='' data-id='' class='close-item'>X</span></div></li>";  
        }
     }
    
    $("ul.add-items-wrapped").html(listHTML);
 } 

printList()

$(document).on("click",".add-items-wrapped .close-item",function() { 
   $(this).parents('.inner-item').remove();
   var id = $(this).data("id");
   var price = $(this).data("price");
  
   theTotal = Number(theTotal) - Number(price);
   $('.total-price').text("$" + theTotal.toFixed(2));
   
    var storage_value = localStorage.getItem("storage_data") ? JSON.parse(localStorage.getItem("storage_data")) : [];
    if(storage_value.length){
      for(var i = 0; i < storage_value.length; i++) {
          var itemid = storage_value[i].id;
          if(itemid == id){ 
              storage_value.splice(i, 1);
              break;
          }     
       }
      localStorage.setItem("storage_data", JSON.stringify(storage_value) );
     }

     if(storage_value.length < 6){
       var listHTML = "<li class='inner-item'><div class='img-box hidden'><img src=''/><span data-price='' data-id='' class='close-item'>X</span></div></li>";  
       $("ul.add-items-wrapped").append(listHTML);
     }
     if(storage_value.length <= 4){
         var left_item = 4 - storage_value.length;
         $('.saving p').text('Currently saving 10% - Add '+left_item+' more for 20% savings');
         if(left_item == 0){
            $('.saving p').text('Congratulations you got 20% savings');
         }
      }
      if(storage_value.length > 4 && storage_value.length <= 6 ){
         var left_item = 6 - storage_value.length;
         $('.saving p').text('Currently saving 20% - Add '+left_item+' more for 30% savings');
         if(left_item == 0){
            $('.saving p').text('Congratulations you got 30% savings');
        }
      }

       if(storage_value.length > 6 ){
         $('.saving p').text('Congratulations you got 30% savings');
       }
  
       if(storage_value.length == 0){
        $('.build-bottom').hide();
       }

           var qtyvaluee = ''
            $.getJSON('/cart.js').then(
                function(cart){
                    cart.items.forEach(function(item) {
                     if(item.id == id){
                         var qty = item.quantity
                         qtyvaluee = qty - 1
                          $('.build-left-box .build-item').find('[data-id="'+id+'"]').next('span.item-count').text(qtyvaluee);
                          $.ajax({
                            type: 'POST',
                            context: this,
                            url: '/cart/change.js',
                            data: { quantity: qtyvaluee, id: id },
                            dataType: 'json',
                            success: function(cart){
                              if(cart.item_count == 0){
                               RemoveCartBuble();
                              }else{
                                $('.cart-count-bubble span').text(cart.item_count);
                              }
                            },
                            error: function(){
                               alert(error.responseJSON['description']);
                            }
                        });
                      }
                    });
                   
                   if(qtyvaluee == 0){
                     $('.build-left-box .build-item').find('[data-id="'+id+'"]').removeClass('active');
                     $('.build-left-box .build-item').find('[data-id="'+id+'"]').text('Add To Your Box');
                     $('.build-left-box .build-item').find('[data-id="'+id+'"]').parents('.build-item').removeClass('border');
                     $('.build-left-box .build-item').find('[data-id="'+id+'"]').next('span.item-count').text('1');
                   }
                  }
               );
      });    

function AddCartBuble(){
     $.getJSON('/cart.js').then(
        function(cart) {
              var shorthtml = '<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg><div class="cart-count-bubble "><span aria-hidden="true"></span></div>'
              if(!$('.cart-count-bubble').length){
                 if($('svg.icon.icon-cart').length == 0){
                     $('#cart-icon-bubble').append(shorthtml)  
                     $('svg.icon.icon-cart-empty').remove();
                }
              } 
              $('.cart-count-bubble span').text(cart.item_count)
              cart.items.forEach(function(item) {
                $('.build-left-box .build-item').find('[data-id="'+item.id+'"]').next('span.item-count').text(item.quantity);
              });
          }.bind(this)
        );
}  
  
function RemoveCartBuble(){
    $.getJSON('/cart.js').then(
        function(cart) {
               $('.cart-count-bubble, svg.icon.icon-cart').remove();
               var shorthtml = '<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"/></svg>'
               $('#cart-icon-bubble').append(shorthtml)
               // cart.items.forEach(function(item) {
               //  // $('.build-left-box .build-item').find('[data-id="'+item.id+'"]').next('span.item-count').text(item.quantity);
               // });
          
        }.bind(this)
      );
 }  
  
function updateCartdrawer(qtyvalue,itemid){
  $.ajax({
    type: 'POST',
    context: this,
    url: '/cart/change.js',
    data: { quantity: qtyvalue, id: itemid } ,
    dataType: 'json',
    success: function() { 
      showCartdrawer(itemid);
    },
    error: function(){
       alert(error.responseJSON['description']);
    }
  });
} 

function showCartdrawer(){
  $.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'html', 
    success: function (result){
      var mini_cart = $(result).find('.cart_content').html();
      $('.mob-build-box .cart_content').html(mini_cart);
      var count = $(result).find('form.js-cart_content__form').attr('data-cart-count');
      $('.build-btn-mob .cart-count, .cart-count-bubble, .cart-count-bubble span').text(count);
      if(count == undefined){
        RemoveCartBuble();
      }
    } 
  });
}
  
$(document).on("click",".js-change-quantity",function(){
  var qtyvalue = parseInt($(this).parents('.product-quantity-box').find('input').val());
  var itemid = $(this).parents('.product-quantity-box').find('input').data('vid');
  var checkpm = $(this).data('func');
  if(checkpm == 'plus'){
    qtyvalue += 1;
  }else{
    qtyvalue -= 1;
  }
  updateCartdrawer(qtyvalue,itemid);
  if(qtyvalue == 0){
     $('.build-left-box .build-item').find('[data-id="'+itemid+'"]').removeClass('active');
     $('.build-left-box .build-item').find('[data-id="'+itemid+'"]').text('Add To Your Box');
     $('.build-left-box .build-item').find('[data-id="'+itemid+'"]').parents('.build-item').removeClass('border');
     $('.build-left-box .build-item').find('[data-id="'+itemid+'"]').next('span.item-count').text('1');
  }
});


});